import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  padding: 0.5rem 0.5rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;

  img {
    width: 90px;
    height: 75px;

    @media only screen and (max-width: 768px) {
      width: 60px;
      height: 49px;
    }

    @media only screen and (max-width: 480px) {
      width: 60px;
      height: 50px;
    }
  }

  h6 {
    color: #4b3a58;
    padding-left: 1rem;
    margin-bottom: 0rem;
    font-size: 2.5rem;

    @media only screen and (max-width: 768px) {
      font-size: 1.2rem;
    }

    @media only screen and (max-width: 480px) {
      font-size: 1rem;
    }
  }
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 1550px) {
    display: block;
  }

  display: none;

  svg {
    fill: #2e186a;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 1550px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #404041;
  transition: color 0.2s ease-in;
  margin: 0.5rem 2rem 2rem 2rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem 2rem 2rem;
  }
`;

export const SidebarNavLink = styled(NavLink)`
  font-size: 1.2rem;
  color: #404041;
  transition: color 0.2s ease-in;
  margin: 0.5rem 0;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const SidebarCallButton = styled("button")`
  background: rgb(75, 58, 88);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid #edf3f5;
  border-radius: 4px;
  padding: 15px 10px;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 280px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);
  white-space: pre-line;
  line-height: 1.4;

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid rgb(122, 93, 163);
    background-color: rgb(122, 93, 163);
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: rgb(184, 155, 94);
    border-bottom: 1px solid rgb(184, 155, 94);
  }
`;
